import { openCreateFinancialDeckModal } from "@/components/CreateFinancialDeckModal/openCreateFinancialDeckModal";
import { Button } from "@mantine/core";
import { BiSolidAddToQueue } from "react-icons/bi";

export const CreateModelButton = ({ disabled }: { disabled?: boolean }) => {
  return (
    <Button
      w={180}
      leftSection={<BiSolidAddToQueue size={20} />}
      onClick={() => openCreateFinancialDeckModal()}
      disabled={disabled}
    >
      Create Model
    </Button>
  );
};
